import * as React from 'react';
import { useEffect, useState } from 'react';
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";
import { setRecoleccionDestino, setRecoleccionOrigen } from "../../redux/actions/recoleccionActions";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import { enums } from "../../enums/enums";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { useSnackbar } from 'notistack';
import { updateServicios } from "../../redux/actions/servicioAdicionalActions";
import { saveTiposEnvio } from "../../redux/actions/tipoEnvioActions";
import { ICliente } from "../../entities/catalogos/ICliente";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import useCommonApi from "../../api/useCommonApi";
import { IUsuario } from '../../entities/catalogos/IUsuario';
import LoadingDialog from '../controls/LoadingDialog';
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import ConfirmDireccion from '../controls/ConfirmDireccion';
import CloseIcon from '@material-ui/icons/Close';
import Map from '../map/Map';
import { saveCliente } from '../../redux/actions/clienteActions';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    createStyles,
    Dialog,
    Grid,
    makeStyles,
    TextField,
    Theme,
    Typography,
    Container,
    IconButton,
    DialogActions,
    Modal,
    FormControlLabel,
    Switch
} from '@material-ui/core';
import { Add, Search, EditLocation } from '@material-ui/icons';
import RecoleccionSolicitud from './RecoleccionSolicitud';
import swal from 'sweetalert2';
import { initialSolicitud } from '../../redux/reducers/solicitudReducer';
import { initialRecoleccionState } from '../../redux/reducers/recoleccionReducer';
import { Recoleccion } from '../../entities/catalogos/Recoleccion';
import { saveMercancias } from '../../redux/actions/mercanciaActions';
import { useHistory } from "react-router-dom";
import Help, { IHelp } from '../help/Help';
import ReferenciaNumberField from '../controls/ReferenciaNumberField';
import { completarValoresRecoleccion, obtenerMercancias, validarCruceSolicitud, validarDestinoInternacional } from "../../blocks/utility";
import useGetInformacionOrigenDestino from "../../hooks/useGetInformacionOrigenDestino";
import {ServicioAdicional} from "../../entities/catalogos/ServicioAdicional";
import {AreaServicio} from "../../entities/catalogos/AreaServicio";
import {IDocumento} from "../../interfaces/IDocumento";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { resolve } from 'dns';
import { CruceInternacional } from '../../entities/catalogos/CruceInternacional';
import ServicioInternacional from '../comercioExterior/ServicioInternacional';
import NextButton from '../controls/NextButton';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            boxShadow: "none"
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            padding: "10px"
        },

        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        title: {
            fontSize: "24px",
            paddingBottom: "20px"
        },
        actions: {
            width: "100%",
            textAlign: "right",
            paddingTop: "20px",
            backgroundColor: "#ccc"

        },
        heading: {
            fontSize: "0.875rem",
            color: "#00653b",
            fontWeight: theme.typography.fontWeightBold,
            borderBottom: "2px solid #00653b"
        },
        headingAdicional: {
            fontSize: theme.typography.pxToRem(20),
            fontWeight: theme.typography.fontWeightBold,
            textAlign: "center"
        },

    }),
);

interface OwnProps {
    siguienteSeccion: (siguienteSeccionId: number, datosSeccion: IRecoleccion, cotizacionId?: number, contacto?: any, datosRemitente?: any, datosDestinatario?: any, proyecto?: any, facturador?: any, observaciones?: string, comercioExterior?: any, cruceFronterizo?: any) => void
    setCotizacionID: (cotizacionId: number) => void
    cotizacionId: number 
}

interface StateProps {
    cliente: ICliente
    recoleccionOrigen: IRecoleccion
    recoleccionDestino: IRecoleccion
    solicitud: Solicitud
    solicitudCopia: Solicitud
    usuario: IUsuario
    serviciosAdicionales: ServicioAdicional[]
    ayuda: IHelp
}

interface DispatchProps {
    saveCliente: typeof saveCliente
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    updateServicios: typeof updateServicios
    saveTiposEnvio: typeof saveTiposEnvio
    saveMercancias: typeof saveMercancias
}

enum Paises {
    EU = "EUA",
    EUA = "EUA"
}

type Props = OwnProps & StateProps & DispatchProps

const OrigenDestinoSolicitud = (props: Props) => {
    const { enqueueSnackbar } = useSnackbar();
    const [destinoHabilitado, setDestinoHabilitado] = useState(props.recoleccionOrigen.completado);
    const [adicionalHabilitado, setAdicionalHabilitado] = useState(false);
    const [comercioExteriorHabilitado, setComercioExteriorHabilitado] = useState(false);
    const [cruceFronterizoId, setCruceFronterizoId] = useState(props.solicitud.cruceFronterizo?.cruceInternacionalId);
    const [sucursalCruceId, setSucursalCruceId] = useState(props.solicitud.cruceFronterizo?.sucursalId);
    const [cruceDescripcion, setCruceFronterizo] = useState(props.solicitud.cruceFronterizo?.cruce);
    const [esInternamientoObligatorio, setEsInternamientoObligatorio] = useState(false);
    const [esInternamiento, setEsInternamiento] = useState(props.solicitud.cruceFronterizo?.esIntraUSA ?? false);
    const { getTipoServicio, saveServicioAdicionales } = useGetInformacionOrigenDestino(props.cliente,
        props.updateServicios, props.saveTiposEnvio);
    const apiSource = useCommonApi();
    const [showLoading, setLoading] = useState(false);
    const classes = useStyles();
    const [expanded, setExpanded] = useState<string | false>('Origen');
    const [observaciones, setObservaciones] = useState(props.solicitud.observaciones);
    const [nocotizacion, setNoCotizacion] = useState('');
    const history = useHistory();
    const [mostrarConfirm, setMostrarConfirm] = useState<boolean>(false);
    const [hayModificacion, setHayModificacion] = useState<boolean>(false);
    const [showAlertGeopunto, setShowAlertGeopunto] = useState(false);
    const [showBuscoGeopunto, setShowBuscoGeopunto] = useState(false);
    const [abierto, setAbierto] = useState(false);
    const [ubicacionOriginal, setUbicacionOriginal] = useState({ latitud: 0, longitud: 0 });
    const [ubicacionVerificada, setUbicacionVerificada] = useState({ latitud: 0, longitud: 0 });
    const [zoom, setZoom] = useState(6);
    const [currentZoom, setCurrentZoom] = useState(0);
    const [googleApi, setGoogleAPI] = useState('');
    const [showAlert, setShowAlert] = useState(true);
    const [guardaDireccionCliente, setGuardaDireccionCliente] = useState(false);
    const [validado, setValidado] = useState(false);
    const [avanza, setAvanza] = useState(false);
    const [cliente, setCliente] = useState(props.cliente);
    const [esRadCedis, setEsRadCedis] = useState(false);
    const [esEadCedis, setEsEadCedis] = useState(false);
    const [switched, setSwitched] = useState(false);
    const [expandedComercioExterior, setExpandedComercioExterior] = useState(false);
    const [cruceInternacionalId, setCruceInternacionalId] = useState(props.solicitud.cruceFronterizo?.cruceInternacionalId);
    const [limpiaCruceFronterizo, setLimpiaCruceFronterizo] = useState(false);
    const [sucursalCruceCP, setSucursalCruceCP] = useState(0);

    React.useEffect(() => {
        if (!props.solicitud || props.solicitud.id === 0) {
            const copiaSolicitud = new Solicitud(props.solicitud);
            if (props.solicitud.cotizacionId) {
                setNoCotizacion(props.solicitud.cotizacionId.toString());
            }
            copiaSolicitud.esSeguroMercancia = false;
            props.setSolicitudCopia(copiaSolicitud);

            if (!props.recoleccionOrigen.completado) {
                setDestinoHabilitado(false);
            }
            if (props.recoleccionDestino.completado) {
                if(copiaSolicitud.esServicioInternacional){
                    setComercioExteriorHabilitado(true);
                    setAdicionalHabilitado(false);
                }
                else{
                    setAdicionalHabilitado(true);
                }                    
            }
        }
        if (props.solicitud.expandeDestinatario === true) {
            setExpanded('Destino');
        }

        if(cliente.clienteConfiguracionRadEadCedis !== undefined && cliente.clienteConfiguracionRadEadCedis !== null){
            setEsRadCedis(cliente.clienteConfiguracionRadEadCedis.activoRad);
            setEsEadCedis(cliente.clienteConfiguracionRadEadCedis.activoEad);
        }

        switch (process.env.NODE_ENV) {
            case "production":
                setGoogleAPI('AIzaSyBTj4udz3JGq5u1TOgfvlD7VJ34JpJz_A4');
                break;
            case "development":
                setGoogleAPI('AIzaSyBTj4udz3JGq5u1TOgfvlD7VJ34JpJz_A4');
                break;
            default:
                setGoogleAPI('AIzaSyDmgCsH-ySX6C7mB4g0dBGj0Lb4mZflAgk');
                break;
        }

        if(props.solicitud && props.solicitud.esHomeDelivery){
            if(props.cliente.esHomeDelivery && props.cliente.tieneConveniosHD)
            setSwitched(props.solicitud.esHomeDelivery);
            else
                setSwitched(false);
        }
        if(props.solicitud && props.solicitud.tipoServicio && props.solicitud.tipoServicio.id !== 3){
            setSwitched(false);
        }
        if(props.solicitud && props.solicitud.tipoServicio && props.solicitud.tipoServicio.id === 3){
            if(props.cliente.esHomeDelivery && props.cliente.tieneConveniosHD)
            setSwitched(true);
            else
                setSwitched(false);
        }

    }, []);

    React.useEffect(() => {
        if(limpiaCruceFronterizo){
            setCruceFronterizoId(0);
            setSucursalCruceId(0);
            setCruceFronterizo("");
            setLimpiaCruceFronterizo(false);
        }
    }, [limpiaCruceFronterizo]);

    const normalizarPais = (pais: string): string => {
        return Paises[pais as keyof typeof Paises] || pais;
    };

    const buscarCoordenadasPorDireccion = async (data) => {
        const paisNormalizado = normalizarPais(data.pais);
        const cData = { ...data, pais: paisNormalizado };
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-geocode-by-address", cData);
        return result;
    }

    const siguientePaso = async (recoleccion: IRecoleccion, esOrigen: boolean, contacto: any) => {
        const recoleccionOrigen: IRecoleccion = esOrigen ? recoleccion : props.recoleccionOrigen;
        const recoleccionDestino: IRecoleccion = !esOrigen ? recoleccion : props.recoleccionDestino;
        
        let copiaSolicitud: Solicitud = new Solicitud({
            ...props.solicitud, tipoSolicitud: "solicitud servicio",
            estatusId: enums.estatusSolicitud.origenDestino, serviciosAdicionales: (props.solicitud.cargaServiciosState === true) ? props.solicitud.serviciosAdicionales : []
        });
        if (nocotizacion !== '') {
            copiaSolicitud.cotizacionId = Number(nocotizacion);
        }

        await guardarDatos(copiaSolicitud, recoleccionOrigen, recoleccionDestino, esOrigen, contacto);
    };

    const obtieneAreaServicioCP = (recoleccion: IRecoleccion, esOrigen, esDestino) => {
        obtenerAreaServicioByCp(recoleccion.distribuidor.codigoPostal).then(res => {
            if (esOrigen === true) {
                localStorage.setItem('ClasificacionAreaServicioOrigen', res.clasificacionID);
            }
            
            if (esDestino === true) {
                localStorage.setItem('ClasificacionAreaServicioDestino', res.clasificacionID);
            }
        });
    }

    const obtenerDireccion = (recoleccion: IRecoleccion, esOrigen) => {
        setValidado(false);
        let esCruceOrigen = esOrigen ? (recoleccion.paisId === enums.pais.usa) : !!props.recoleccionOrigen?.esServicioInternacional;
        let esCruceDestino = !esOrigen ? (recoleccion.paisId === enums.pais.usa) : !!props.recoleccionDestino?.esServicioInternacional;
        let esServicioInternacional = (esCruceOrigen || esCruceDestino);

        if(esServicioInternacional){
            setExpandedComercioExterior(true);
        }                        
        const data = {
            subscriptionKey: googleApi,
            cp: recoleccion.distribuidor.codigoPostal,
            pais: recoleccion.distribuidor.colonia.pais.nombre,
            estado: recoleccion.distribuidor.colonia.estado.nombre,
            ciudad: recoleccion.distribuidor.colonia.ciudad.nombre,
            colonia: recoleccion.distribuidor.colonia.nombreColonia,
            calle: recoleccion.distribuidor.calle,
            calleNo: recoleccion.distribuidor.noExterior,
            username: localStorage.getItem("usuario_nombre")
        };
        setLoading(true);
        getDistribuidorDireccionCliente(props.cliente.id,recoleccion.distribuidor.id).then(res => {
            if (res.l_VERIFICADO) {
                setValidado(true);
                return;
            }
            else{
                if(res.latitudOriginal!==0 && res.longitudOriginal!==0){
                    setUbicacionVerificada({latitud: res.latitudVerificada, longitud: res.longitudVerificada});
                    setUbicacionOriginal({latitud: res.latitudOriginal, longitud: res.longitudOriginal});
                    setZoom(16);
                    setGuardaDireccionCliente(false);
                }
                if(res.latitudOriginal===0 && res.longitudOriginal===0){
                    setGuardaDireccionCliente(true);
                }
                buscarCoordenadasPorDireccion(data).then(resAddress => {
                    if (resAddress !== null && (resAddress['results'] === undefined ? false : resAddress['results'].length)) {
                        if (resAddress['results'][0]['geometry'] !== undefined) {
                            setUbicacionOriginal({ latitud: resAddress['results'][0]['geometry']['location']['lat'], longitud: resAddress['results'][0]['geometry']['location']['lng'] });
                            setZoom(16);
                            setAvanza(true);
                        }
                    }
                    else{
                        data.calle='';
                        data.calleNo=0;
                        buscarCoordenadasPorDireccion(data).then(resAddress => {

                            if (resAddress !== null && (resAddress['results'] === undefined ? false : resAddress['results'].length)) {
                                if (resAddress['results'][0]['geometry'] !== undefined) {
                                    setUbicacionOriginal({ latitud: resAddress['results'][0]['geometry']['location']['lat'], longitud: resAddress['results'][0]['geometry']['location']['lng'] });
                                    setZoom(16);
                                    setAvanza(true);
                                }
                            }
                            else if(resAddress['status']==='REQUEST_DENIED'){
                                setLoading(false);
                                setValidado(true);
                                return;
                            }
                        });
                    }
                }).catch(err => {
                    alert(err)
                });
            }
        }).catch(err => {
            alert(err);
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const obtenerServicios = (recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion,
        esOrigen: boolean): ServicioAdicional[] | undefined => {
        //Se obtinen los servicios del destino en caso de estar en el origen, o los servicios del origen en caso contario
        const serviciosPorCambiar = esOrigen ? recoleccionDestino.serviciosAdicionales : recoleccionOrigen.serviciosAdicionales;
        const servicios = esOrigen ? recoleccionOrigen.serviciosAdicionales : recoleccionDestino.serviciosAdicionales;
        const retornoDocumentosSeleccionado = servicios?.find(e => e.esRetornoDocumentos && e.seleccionado);
        const retornoDocumentos = serviciosPorCambiar?.find(e => e.esRetornoDocumentos);

        if (!retornoDocumentosSeleccionado || !retornoDocumentos) return serviciosPorCambiar;

        let nuevosServicios: ServicioAdicional[] = [];

        serviciosPorCambiar?.forEach(e => {
            const nuevoServicio = new ServicioAdicional(e);

            if (e.esRetornoDocumentos) {
                nuevoServicio.documentos = retornoDocumentosSeleccionado.documentos;
            }

            nuevosServicios.push(nuevoServicio);
        });

        return nuevosServicios;
    }

    const verificaAS = async (recoleccion, esOrigen) => {
        
        let params ={
            paisId: recoleccion.colonia.pais?.id,
            estadoId: recoleccion.colonia.estado?.id,
            ciudadId: recoleccion.colonia.ciudad?.id,
            codigoPostal: recoleccion.colonia?.codigoPostal,
            empresaId: cliente?.empresaID,
            ClienteID: cliente?.id,
            ClienteDistribuidorID: recoleccion.distribuidor?.clienteDistribuidorID
        };
        const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", params);
        if(esOrigen) {
            if(result.areaServicioRadEadCedis?.activoRad !== undefined){
                return result.areaServicioRadEadCedis?.activoRad;
            }
            else{
                return false;
            }
        }
        if(!esOrigen) {
            if(result.areaServicioRadEadCedis?.activoEad !== undefined){
                return result.areaServicioRadEadCedis?.activoEad;
            }
            else{
                return false;
            }
        }
            return false
    }

    const guardarDatos = async (copiaSolicitud: Solicitud, recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion,
        esOrigen: boolean, contacto: any) => {
        let mensaje = traducirMessage(202) + ' ' //"NO SE PERMITE LA RECOLECCIÓN CON CITA PARA "
            + recoleccionOrigen?.areaServicio?.nombre;
        if (esOrigen) {
            props.updateServicios([]);
            const serviciosDestino = obtenerServicios(recoleccionOrigen, recoleccionDestino, true);
            props.setRecoleccionDestino({ ...recoleccionDestino, serviciosAdicionales: serviciosDestino });

            if(recoleccionOrigen?.fechaCitaCedis !== undefined || recoleccionOrigen.EsCitaRadCedis)
            {
                if (recoleccionOrigen?.areaServicio?.areaServicioRadEadCedis?.activoRad === false)
                {
                    mensaje = traducirMessage(315) + ' ' + recoleccionOrigen?.areaServicio?.nombre;   //"NO SE PERMITE LA RECOLECCIÓN CON CITA CEDIS PARA "
                    swal.fire({
                        titleText: traducirMessage(276), // '¡Atención!',
                        text: mensaje,
                        type: 'warning',
                    });
                    return false;
                }
                if(recoleccionOrigen?.areaServicio?.areaServicioRadEadCedis?.activoRad === undefined || esRadCedis ===undefined){
                    verificaAS(recoleccionOrigen, esOrigen).then(res => {
                        if(!res){
                            mensaje = traducirMessage(315) + ' ' + recoleccionOrigen?.areaServicio?.nombre;   //"NO SE PERMITE LA RECOLECCIÓN CON CITA CEDIS PARA "
                            swal.fire({
                                titleText: traducirMessage(276), // '¡Atención!',
                                text: mensaje,
                                type: 'warning',
                            });
                            return false;
                        }
                    });
                }
            }


            guardarOrigen(copiaSolicitud, recoleccionOrigen, contacto);
        } else {
            if(recoleccionOrigen.eliminaRetornoDocumentos){
                copiaSolicitud.eliminaRetornoDocumentos = true;
            }else{
                copiaSolicitud.eliminaRetornoDocumentos = false;
            }
            const errorCruce = validarDestinoInternacional(recoleccionOrigen, recoleccionDestino);
            if (errorCruce) {
                swal.fire({
                    titleText: traducirMessage(11), // 'Aviso',
                    text: errorCruce,
                    type: 'error'
                });
                return false;
            }
            
            const errorServicios = validarServicios(recoleccionOrigen.serviciosAdicionales, recoleccionDestino.serviciosAdicionales);
            if (errorServicios !== "") {
                enqueueSnackbar(errorServicios, { variant: "error" });
                return false;
            }
            if(recoleccionDestino?.fechaCitaCedis !== undefined || recoleccionDestino.EsCitaRadCedis)
            {
                if (recoleccionDestino?.areaServicio?.areaServicioRadEadCedis?.activoEad === false)
                {
                    mensaje = traducirMessage(316) + ' ' + recoleccionDestino?.areaServicio?.nombre;   //"NO SE PERMITE LA ENTREGA CON CITA CEDIS PARA "
                    swal.fire({
                        titleText: traducirMessage(276), // '¡Atención!',
                        text: mensaje,
                        type: 'warning',
                    });
                    return false;
                }

                if(recoleccionDestino?.areaServicio?.areaServicioRadEadCedis?.activoEad === undefined || esEadCedis ===undefined){
                    verificaAS(recoleccionOrigen, esOrigen).then(res => {
                        if(!res){
                            mensaje = traducirMessage(316) + ' ' + recoleccionDestino?.areaServicio?.nombre;   //"NO SE PERMITE LA ENTREGA CON CITA CEDIS PARA "
                            swal.fire({
                                titleText: traducirMessage(276), // '¡Atención!',
                                text: mensaje,
                                type: 'warning',
                            });
                            return false;
                        }
                    });
                }
            }
            setLoading(true);

            const serviciosOrigen = obtenerServicios(recoleccionOrigen, recoleccionDestino, false);
            props.setRecoleccionOrigen({ ...recoleccionOrigen, serviciosAdicionales: serviciosOrigen, recalcularServicios: false });

            copiaSolicitud.serviciosAdicionalesOrigen = serviciosOrigen;
            let resultTipoServicio =  await getTipoServicio(recoleccionOrigen, recoleccionDestino);
            copiaSolicitud.tipoServicio = resultTipoServicio;
            copiaSolicitud.tipoServicioReal = resultTipoServicio;
            
            if(switched){
                let tipoServicio = {id: 3 , nombre: 'HOME DELIVERY'}
                copiaSolicitud.tipoServicio.id = tipoServicio.id;
                copiaSolicitud.tipoServicio.nombre = tipoServicio.nombre;
                copiaSolicitud.esHomeDelivery = true;
            }

            if (recoleccionOrigen.recalcularServicios || recoleccionDestino.recalcularServicios || !props.serviciosAdicionales?.length) {
                await saveServicioAdicionales(recoleccionOrigen, recoleccionDestino, copiaSolicitud);
            }

            guardarDestino(copiaSolicitud, recoleccionDestino, contacto);

            setLoading(false);
        }
    }

    const configurarCruceFronterizo = (recoleccion: IRecoleccion, esOrigen: boolean, copiaSolicitud: Solicitud) => {
        let esCruceOrigen = esOrigen ? !!recoleccion.esServicioInternacional : !!props.recoleccionOrigen?.esServicioInternacional;
        let esCruceDestino = !esOrigen ? !!recoleccion.esServicioInternacional : !!props.recoleccionDestino?.esServicioInternacional;
        let esServicioInternacional = (esCruceOrigen || esCruceDestino);

        if(esServicioInternacional){
            let esOrigenSinAreaServicio = esOrigen ? (recoleccion.sinAreaServicio && recoleccion.paisId == 2) : (!!props.recoleccionOrigen?.sinAreaServicio && props.recoleccionOrigen?.paisId == 2);
            let esDestinoSinAreaServicio = !esOrigen ? (recoleccion.sinAreaServicio && recoleccion.paisId == 2) : (!!props.recoleccionDestino?.sinAreaServicio && props.recoleccionDestino?.paisId == 2);
            if(esOrigenSinAreaServicio || esDestinoSinAreaServicio){
                setEsInternamientoObligatorio(true);
                setEsInternamiento(true);     
            }
            else{
                setEsInternamientoObligatorio(false);
            }
            
            if(expanded == 'Destino'){
                setExpanded('ComercioExterior');
                setComercioExteriorHabilitado(true);
            }
        }
        else{
            setEsInternamiento(false);
            setEsInternamientoObligatorio(false);
            let nuevaSolicitud: Solicitud = new Solicitud({...copiaSolicitud});
            nuevaSolicitud.SetComercioExterior(null);
            nuevaSolicitud.SetCruceFronterizo(null);
            props.setSolicitud(nuevaSolicitud);
            props.setSolicitudCopia(nuevaSolicitud);
        }
    }

    const guardarOrigen = (copiaSolicitud: Solicitud, recoleccion: IRecoleccion, contacto: any) => {
        var limpiarCruce = false;
        if(recoleccion.EsCitaRadCedis !== undefined && recoleccion.EsCitaRadCedis && copiaSolicitud.cotizacionId === undefined){
            recoleccion.fechaCitaCedis = recoleccion.fechaCita;
            recoleccion.fechaCita = undefined;
        }

        if(recoleccion.codigoPostal !== props.recoleccionOrigen.codigoPostal)
            limpiarCruce = true;
        
        props.setRecoleccionOrigen(recoleccion);

        if (recoleccion.tipoRecoleccionId !== 3) {
            if (!recoleccion.EsFueraHorario && !recoleccion.fechaCita && !recoleccion.fechaRecoleccion && !recoleccion.fechaCitaCedis) {
                enqueueSnackbar(traducirMessage(122), //"Favor de seleccionar la fecha de recolección.", 
                    { variant: "error" });
                return;
            }

            if (recoleccion.aceptaCita && !recoleccion.fechaCita && !recoleccion.fechaRecoleccion && !recoleccion.fechaCitaCedis) {
                enqueueSnackbar(traducirMessage(124),//"Favor de seleccionar la fecha y hora de recolección.",
                    { variant: "error" });
                return;
            }

            if(recoleccion.serviciosAdicionales)
            {
                for (let i = 0; i < recoleccion.serviciosAdicionales.length; i++) {
                    if(recoleccion.serviciosAdicionales[i].documentos)
                    {
                        let docexitente=recoleccion.serviciosAdicionales[i].documentos?.length??0;
                        let doc=recoleccion.serviciosAdicionales[i].documentos;
                        for (let x = 0; x < docexitente; x++) {
                            if(doc?.[x].documento=="" || !doc?.[x].documento )
                            {
                                //"Favor de capturar el nombre del documento."
                                enqueueSnackbar(traducirMessage(283), {variant: "error"});
                                return;
                            }

                        }
                    }
                    else {
                        if(recoleccion.serviciosAdicionales[i].seleccionado && recoleccion.serviciosAdicionales[i].nombre==="RETORNO DOCUMENTOS")
                        {
                            enqueueSnackbar(traducirMessage(283), {variant: "error"});
                            return;
                        }
                    }
                }

            }
        }
        
        //Guarda los valores de la recolección de origén en la solicitud original
        copiaSolicitud.SetOrigen(recoleccion);
        copiaSolicitud.SetContactoOrigen(contacto);
        copiaSolicitud.SetDistribuidorRemitente(recoleccion.distribuidor);
        
        if(copiaSolicitud.cotizacionId !== undefined && copiaSolicitud.cotizacionId === 0 && recoleccion.EsCitaRadCedis !== undefined && recoleccion.EsCitaRadCedis){
            if(recoleccion.fechaCita !== undefined){
                copiaSolicitud.fechaCitaRadCedis = recoleccion.fechaCita;
                copiaSolicitud.fechaCitaRad = undefined;
            }
        }
        
        props.setSolicitudCopia(copiaSolicitud);
        props.setSolicitud(copiaSolicitud);
        obtieneAreaServicioCP(recoleccion, true, false);
        configurarCruceFronterizo(recoleccion, true, copiaSolicitud);
        obtenerDireccion(recoleccion, true);
        setLimpiaCruceFronterizo(limpiarCruce);
    }

    const guardarDestino = (copiaSolicitud: Solicitud, recoleccion: IRecoleccion, contacto: any) => {
        var limpiarCruce = false;
        if(recoleccion.codigoPostal !== props.recoleccionDestino.codigoPostal)
            limpiarCruce = true;
        if (recoleccion.tipoRecoleccionId !== 3) {
            if (recoleccion.EsFueraHorario && !recoleccion.fechaCita && !recoleccion.fechaRecoleccion && !recoleccion.fechaCitaCedis) {
                enqueueSnackbar(traducirMessage(238), //"Favor de seleccionar la fecha de entrega.", 
                    { variant: "error" });
                return;
            }

            if (recoleccion.aceptaCita && !recoleccion.EsFueraHorario && !recoleccion.fechaCita && recoleccion?.tipoDeRecoleccionDestino !== 1 && !recoleccion.fechaRecoleccion && !recoleccion.fechaCitaCedis) {
                if(copiaSolicitud?.tipoDeRecoleccionDestino!==1){
                    enqueueSnackbar(traducirMessage(238),//"Favor de seleccionar la fecha y hora de entrega.",
                    { variant: "error" });
                    return;
                }
                
            }
        }
        if(recoleccion.serviciosAdicionales)
        {
            for (let i = 0; i < recoleccion.serviciosAdicionales.length; i++) {
                if(recoleccion.serviciosAdicionales[i].documentos)
                {
                    let docexitente=recoleccion.serviciosAdicionales[i].documentos?.length??0;
                    let doc=recoleccion.serviciosAdicionales[i].documentos;
                    for (let x = 0; x < docexitente; x++) {
                        if(doc?.[x].documento=="" || !doc?.[x].documento )
                        {
                            enqueueSnackbar(traducirMessage(283), {variant: "error"});
                            return;
                        }

                    }
                }
                else {
                    if(recoleccion.serviciosAdicionales[i].seleccionado && recoleccion.serviciosAdicionales[i].nombre==="RETORNO DOCUMENTOS")
                    {
                        enqueueSnackbar(traducirMessage(283), {variant: "error"});
                        return;
                    }
                }
            }

        }
        if(recoleccion.EsCitaEadCedis !== undefined && recoleccion.EsCitaEadCedis && copiaSolicitud.cotizacionId === undefined){
            recoleccion.fechaCitaCedis = recoleccion.fechaCita;
            recoleccion.fechaCita = undefined;
        }
        const serviciosDestino = recoleccion.serviciosAdicionales;
        const copiaRecoleccionDestino = { ...recoleccion, serviciosAdicionales: serviciosDestino, recalcularServicios: false };
        if(switched){
            recoleccion.esHomeDelivery = true;
            copiaSolicitud.esHomeDelivery = true;
            copiaRecoleccionDestino.esHomeDelivery = true;
        }
        if(!switched){
            recoleccion.esHomeDelivery = false;
            copiaSolicitud.esHomeDelivery = false;
            copiaRecoleccionDestino.esHomeDelivery = false;
        }
        copiaSolicitud.SetDestino(recoleccion);
        copiaSolicitud.SetContactoDestino(contacto);
        copiaSolicitud.SetDistribuidorDestinatario(recoleccion.distribuidor);
        props.setRecoleccionDestino(copiaRecoleccionDestino);
        if(copiaSolicitud.cotizacionId !== undefined && copiaSolicitud.cotizacionId === 0 && recoleccion.EsCitaEadCedis !== undefined && recoleccion.EsCitaEadCedis){
            copiaSolicitud.fechaCitaEadCedis = recoleccion.fechaCita;
            copiaSolicitud.fechaCitaEad = undefined;
        }
        props.setSolicitudCopia(copiaSolicitud);
        props.setSolicitud(copiaSolicitud);
        obtieneAreaServicioCP(recoleccion, false, true);
        configurarCruceFronterizo(recoleccion, false, copiaSolicitud);
        obtenerDireccion(recoleccion,false);  
        setLimpiaCruceFronterizo(limpiarCruce);
    }

    const handleCruceInternacional = (cruce: CruceInternacional | undefined) => {
        if(cruce != undefined && cruce != null){
            setCruceFronterizoId(cruce.id);
            setSucursalCruceId(cruce.sucursalID);
            setCruceFronterizo(cruce.cruce);
        }
        else if (cruceInternacionalId != undefined && cruceInternacionalId != null){
            setCruceFronterizoId(cruceInternacionalId);
            setSucursalCruceId(sucursalCruceId);
            setCruceFronterizo(cruceDescripcion);
        }
        else{
            setCruceFronterizoId(0);
            setSucursalCruceId(0);
            setCruceFronterizo('');
        }
   }

   const handleIntraUSA = (intraUSA: boolean) => {
        setEsInternamiento(intraUSA);
    }

   const guardarComercioExterior = () =>{
        let comext, cruce, esCruceOrigen;
        let cruceId = cruceFronterizoId ? cruceFronterizoId : (cruceInternacionalId ? cruceInternacionalId : 0);
        let sucursalId = sucursalCruceId ?? 0;
        let cruceDescrip = cruceDescripcion ?? '';

        if(esInternamiento){//folio 3823
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(324), // 'El cruce fronterizo no es válido para el servicio Intra USA.',
                type: 'info'
            });
        }///fin 3823

        if(cruceId > 0){
            comext = { 
                tipoComercioExteriorId : enums.tipoComercioExterior.internacional
            };
    
            cruce = {
                tipoServicioInternacionalId : 1,
                tipoMovimientoServicioInternacionalId: (props.recoleccionOrigen.esServicioInternacional ? enums.tipoMovimientoServicioInternacional.southbound : enums.tipoMovimientoServicioInternacional.northbound),
                cruceInternacionalId: cruceId,
                esIntraUSA: esInternamiento,
                sucursalCruceId: sucursalId,
                cruce: cruceDescrip
            };

            esCruceOrigen = !!props.recoleccionOrigen.esServicioInternacional;
        }

        let nuevaSolicitud: Solicitud = new Solicitud({
            ...props.solicitudCopia            
            , comercioExterior: comext
            , cruceFronterizo: cruce
            , esCruceOrigen: esCruceOrigen
            , esComercioExterior: (comext != undefined)
            , esServicioInternacional: (cruce != undefined)
        });

       const errorCruce = validarCruceSolicitud(props.recoleccionOrigen, props.recoleccionDestino, nuevaSolicitud);
       if (errorCruce !== "") {
           swal.fire({
                       titleText: traducirMessage(11), // 'Aviso',
                       text: errorCruce,
                       type: 'error'
                   });
           return;
       }
       nuevaSolicitud.SetComercioExterior(comext);
       nuevaSolicitud.SetCruceFronterizo(cruce);
       props.setSolicitud(nuevaSolicitud);
       props.setSolicitudCopia(nuevaSolicitud);
       setExpanded('Adicional');
       setAdicionalHabilitado(true);
   }

    const validaIntraSucursalCruceSucursal = ()=>{

        let areaServicioOrigen = props.recoleccionOrigen?.areaServicio?.id ?? 0;
        let areaServicioDestino = props.recoleccionDestino?.areaServicio?.id ?? 0;
        let sucursalCruceIdV = sucursalCruceId ?? 0;
        let sucursalOrigenCP = props.recoleccionOrigen?.sucursal?.id ?? 0;
        let sucursalDestinoCP = props.recoleccionDestino?.sucursal?.id ?? 0

        if((areaServicioOrigen!=0 && props.recoleccionOrigen.paisId == 2) && sucursalCruceIdV != sucursalOrigenCP){
            setEsInternamientoObligatorio(false);
            setEsInternamiento(false);    
        }

        if((areaServicioDestino!=0 && props.recoleccionDestino.paisId == 2) && sucursalCruceIdV != sucursalDestinoCP){
            setEsInternamientoObligatorio(false);
            setEsInternamiento(false);
        }

        if((areaServicioOrigen == 0 && props.recoleccionOrigen.paisId == 2) && sucursalCruceIdV != sucursalOrigenCP){
            setEsInternamientoObligatorio(true);
            setEsInternamiento(true);
        }

        if((areaServicioDestino == 0 && props.recoleccionDestino.paisId == 2) && sucursalCruceIdV != sucursalDestinoCP){
            setEsInternamientoObligatorio(true);
            setEsInternamiento(true);
        }

        if((areaServicioOrigen!=0 && props.recoleccionOrigen.paisId == 2) && sucursalCruceIdV === sucursalOrigenCP){
            setEsInternamientoObligatorio(false);
           setEsInternamiento(false);
        }

        if((areaServicioDestino!=0 && props.recoleccionDestino.paisId == 2) && sucursalCruceIdV === sucursalDestinoCP){
            setEsInternamientoObligatorio(false);
            setEsInternamiento(false);
        }
        //4233

        if(areaServicioOrigen!=0 && props.recoleccionOrigen.paisId == 2){   
            setSucursalCruceCP(sucursalOrigenCP);
        }

        if(areaServicioDestino!=0 && props.recoleccionDestino.paisId == 2){
            setSucursalCruceCP(sucursalDestinoCP);
        }

        if(areaServicioOrigen == 0 && props.recoleccionOrigen.paisId == 2){
            setSucursalCruceCP(0);
        }

        if(areaServicioDestino == 0 && props.recoleccionDestino.paisId == 2){
            setSucursalCruceCP(0);
        }

        if(areaServicioOrigen!=0 && props.recoleccionOrigen.paisId == 2){
           setSucursalCruceCP(sucursalOrigenCP);
        }

        if(areaServicioDestino!=0 && props.recoleccionDestino.paisId == 2){
            setSucursalCruceCP(sucursalDestinoCP);
        }
    }

   const guardarSeccion = () => {
        if (!props.solicitud.contactoOrigen?.clienteDistribuidorID || !props.solicitud.contactoDestino?.clienteDistribuidorID) {
            setExpanded(!props.solicitud.contactoOrigen?.id ? 'Origen' : 'Destino');
            const mensaje = !props.solicitud.contactoOrigen?.id ? traducirMessage(113) // 'remitente.'
                : traducirMessage(112) //'destinatario.'
            // "Favor de seleccionar contacto del " +
            enqueueSnackbar(mensaje, { variant: "error" });

            return;
        }

        const getClasificacionID = localStorage.getItem('ClasificacionAreaServicio')
        const getCartaPorte = localStorage.getItem('CartaPorte');

        if (getClasificacionID === "4" || getClasificacionID === "5" || getCartaPorte === "true") {
            setExpanded("DetalleMercanciaComplementaria");
        }

        props.siguienteSeccion(enums.estatusSolicitud.datosMercancia, props.recoleccionDestino, nocotizacion !== '' ? Number(nocotizacion) : 0, props.solicitud.contactoDestino, null, null, null, null, observaciones,props.solicitud.comercioExterior, props.solicitud.cruceFronterizo);
    }

    const validarServicios = (serviciosOrigen, serviciosDestino): string => {
        const totalDocumentosCliente = props.cliente.documentos != null ? props.cliente.documentos.length : 0;
        const origenSeleccionados = serviciosOrigen.filter(e => e.seleccionado);
        const destinoSeleccionados = serviciosDestino.filter(e => e.seleccionado);
        const origenRequeridos = serviciosOrigen.filter(e => (!!e.esRequerido && !e.seleccionado ) || (e.nombre == "RETORNO DOCUMENTOS" && e.esRetornoDocumentos && !e.seleccionado && totalDocumentosCliente > 0)
            && !destinoSeleccionados.some(s => s.id === e.id));
        const destinoRequeridos = serviciosDestino.filter(e => !!e.esRequerido && !e.seleccionado
            && !origenSeleccionados.some(s => s.id === e.id));

        const serviciosRequeridos = origenRequeridos.length > 0 || destinoRequeridos.length > 0;
        let retornoDocumentos = serviciosOrigen?.find(e => e.esRetornoDocumentos && e.seleccionado);
        retornoDocumentos = retornoDocumentos || serviciosDestino?.find(e => e.esRetornoDocumentos && e.seleccionado)
        let servicioSinDocumentos = retornoDocumentos != null && !retornoDocumentos?.documentos?.length
        if (retornoDocumentos?.documentos != undefined)
            if (retornoDocumentos?.documentos.length)
                if (retornoDocumentos?.documentos[0]?.documento == "")
                    servicioSinDocumentos = true;
        let mensaje = "";
        if (serviciosRequeridos || servicioSinDocumentos) {
            mensaje = serviciosRequeridos ? traducirMessage(126) //"Favor de seleccionar los adicionales requeridos."
                : traducirMessage(98); //"Favor de capturar los retornos de documentos.";
        }

        return mensaje;
    }

    const handleChangePanel = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
        setAvanza(false);
    };

    const obtenerAreaServicio = async (areaServicioId) => {
        let result: AreaServicio = await apiSource.obtenerPorIdAsync("area-servicio", areaServicioId);
        console.log(result)
        return new AreaServicio(result);
    }

    const buscarCotizacion = () => {
        if (!nocotizacion) {
            enqueueSnackbar(traducirMessage(106), //"Favor de proporcionar el No.Cotización.",
                { variant: "error" });
            return;
        }

        setLoading(true);
        getFullCotizacion(nocotizacion).then(async response => {
            if (response.cotizacionID > 0) {
                /* Solicitud*/
                const nuevaSolicitudServicio = new Solicitud(initialSolicitud);
                const clienteValido = (await validaCliente(response.cliente.id)) === 1;
                const error = nuevaSolicitudServicio.ValidarCotizacion(response, props.cliente, clienteValido);

                if (error !== "") {
                    swal.fire({
                        titleText: traducirMessage(11), //'¡Aviso!',
                        text: error,
                        type: 'warning',
                    });
                    setNoCotizacion("");
                    setLoading(false);
                    return;
                }

                nuevaSolicitudServicio.SetValores(response, false, false);
                nuevaSolicitudServicio.seccionId = 2;
                nuevaSolicitudServicio.facturador = props.solicitud.facturador;
                nuevaSolicitudServicio.estatusId = 2;

                /* Origen*/
                const recoleccionOrigen = new Recoleccion(initialRecoleccionState);
                recoleccionOrigen.SetValores(response, true, true);
                recoleccionOrigen.areaServicio = await obtenerAreaServicio(response.areaServicioRemitente.id);
                recoleccionOrigen.codigoPostal = response.codigoPostalOrigen;
                const fechaRAD = new Date(response.fechaCitaRAD);
                const fechaRADCedis = (response.cotizacionRadEadCedis === null) ? new Date('1900-01-01T00:00:00') : new Date(response.cotizacionRadEadCedis.fechaCitaRADCedis);
                const fechaDefault = new Date('1900-01-01T00:00:00');
                if (fechaDefault.getFullYear() != fechaRAD.getFullYear())
                    recoleccionOrigen.fechaCita = fechaRAD;
                if (fechaDefault.getFullYear() !== fechaRADCedis.getFullYear() && response.cotizacionRadEadCedis.esRadCitaCedis == true){
                    recoleccionOrigen.fechaCita = fechaRADCedis;
                    recoleccionOrigen.EsCitaRadCedis = true;
                }
                if (fechaDefault.getFullYear() === fechaRADCedis.getFullYear() && fechaDefault.getFullYear() === fechaRAD.getFullYear())
                    recoleccionOrigen.fechaCita = undefined;


                recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.comercial;
                if (response.esResidencialOrigen == true) {
                    recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.residencial;
                }
                if (response.ocurreOrigen == true) {
                    recoleccionOrigen.tipoRecoleccionId = enums.tipoRecoleccion.ocurre;
                }

                if (response.esRadCitaFueraHorario == true) {
                    recoleccionOrigen.EsFueraHorario = response.esRadCitaFueraHorario;
                    recoleccionOrigen.horaFHDe = nuevaSolicitudServicio.RadCitaHoraDe;
                    recoleccionOrigen.horaFHHasta = nuevaSolicitudServicio.RadCitaHoraHasta;
                }


                completarValoresRecoleccion(recoleccionOrigen, recoleccionOrigen.areaServicio, props.cliente, true);

                /* Destino*/
                const recoleccionDestino = new Recoleccion(initialRecoleccionState);
                recoleccionDestino.SetValores(response, false, true);
                recoleccionDestino.areaServicio = await obtenerAreaServicio(response.areaServicioDestinatario.id);
                recoleccionDestino.codigoPostal = response.codigoPostalDestino;
                nuevaSolicitudServicio.tipoDeRecoleccionDestino = 1;
                const fechaCitaEAD = new Date(response.fechaCitaEAD);
                const fechaCitaEADCedis = (response.cotizacionRadEadCedis.esEADCitaCedis !== false) ? new Date('1900-01-01T00:00:00') : new Date(response.cotizacionRadEadCedis.fechaCitaEADCedis);
                const fechaDefaultEAD = new Date('1900-01-01T00:00:00');
                const fechaDefaulCitaEAD = new Date('1900-01-01T00:00:00');
                if (fechaDefaultEAD.getFullYear() === fechaCitaEAD.getFullYear() && response.esEadCita === 1 || fechaDefaulCitaEAD.getFullYear() === fechaDefaulCitaEAD.getFullYear() && response.esEadCita === 1){
                    recoleccionDestino.fechaCita = fechaCitaEAD;
                    nuevaSolicitudServicio.tipoDeRecoleccionDestino = 2;
                }
                if (fechaCitaEADCedis.getFullYear() === fechaCitaEADCedis.getFullYear() && response.cotizacionRadEadCedis.esEadCitaCedis === true){
                    recoleccionDestino.fechaCita = fechaCitaEADCedis;
                    recoleccionDestino.EsCitaEadCedis = true;
                    nuevaSolicitudServicio.tipoDeRecoleccionDestino = 4;
                }
                if (fechaDefaultEAD.getFullYear() === fechaCitaEADCedis.getFullYear() && fechaDefaultEAD.getFullYear() === fechaCitaEAD.getFullYear())
                    recoleccionDestino.fechaCita = undefined;

                recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.comercial;
                if (response.esResidencialDestino == true) {
                    recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.residencial;
                }
                if (response.ocurreDestino == true) {
                    recoleccionDestino.tipoRecoleccionId = enums.tipoRecoleccion.ocurre;
                }

                if (response.esEadCitaFueraHorario == true) {
                    recoleccionDestino.EsFueraHorario = response.esEadCitaFueraHorario;
                    recoleccionDestino.horaFHDe = nuevaSolicitudServicio.EadCitaHoraDe;
                    recoleccionDestino.horaFHHasta = nuevaSolicitudServicio.EadCitaHoraHasta;
                    nuevaSolicitudServicio.tipoDeRecoleccionDestino = 3;
                }

                completarValoresRecoleccion(recoleccionDestino, recoleccionDestino.areaServicio, props.cliente, false);

                nuevaSolicitudServicio.tipoServicio = await getTipoServicio(recoleccionOrigen, recoleccionDestino);
                await saveServicioAdicionales(recoleccionOrigen, recoleccionDestino, nuevaSolicitudServicio, true);

                props.setSolicitud(nuevaSolicitudServicio);
                props.setSolicitudCopia(nuevaSolicitudServicio);
                props.setRecoleccionOrigen(recoleccionOrigen);
                props.setRecoleccionDestino(recoleccionDestino);

                /* Mercancias */
                obtenerMercancias(response, props.saveMercancias, true);

                setLoading(false);
                setExpanded("Origen")
            } else {
                setLoading(false);
                swal.fire({
                    titleText: traducirMessage(276), // '¡Atención!',
                    text: traducirMessage(197), //"No se encontró información sobre la Cotización.",
                    type: 'warning',

                });
            }
        }).catch(() => {
            setLoading(false);
            swal.fire({
                titleText: traducirMessage(276), //'¡Atención!',
                text: traducirMessage(197), //"No se encontró información sobre la Cotización.",
                type: 'warning',

            });
        });

    }

    const validaCliente = async (cliente) => {
        let params = {
            clienteId: cliente.toString(),
            modulo: "SOLICITUD SERVICIO EXTERNO NUEVO",
            evento: "BUSCAR COTIZACION",
            username: localStorage.getItem("usuario_nombre")
        };

        return await apiSource.postAsync<number>("solicitud-servicio/valida-cliente-datos-cFDI", params);
    }

    const getFullCotizacion = async (cotizacionId) => {
        return await apiSource.obtenerAsync<any>("/cotizacion/get-full-cotizacion/" + Number(cotizacionId), {username: props.usuario.nombre});
    }

    const handleObservaciones = (data: any) => {
        let value = data;
        value = value.replace(/[^a-zA-Z0-9 ]/g, "");
        setObservaciones(value);
    }

    const getDistribuidorDireccionCliente = async (clienteId,clienteDistribuidorId) => {
        const data = { clienteId: clienteId, clienteDistribuidorId: clienteDistribuidorId };
        const result = await apiSource.obtenerAsync<any>("cliente-distribuidor-direccion/by-cliente-distribuidor/", data);
        return result;
    };

    // NUEVA FUNCIÓN PERSONALIZADA PARA OBTENER AREA DE SERVICIO
    const obtenerAreaServicioByCp = async (codigoPostal) => {
        const data = { cp: codigoPostal};
        const result = await apiSource.obtenerAreaServicioPorCpAsync<any>("area-servicio/by-cp", data);
        return result;
    }

    const mostrarConfirmarCerrar = () => {
        if (hayModificacion)
            setMostrarConfirm(true);
        else{
            if(expanded==='Origen'){
                setExpanded('Destino');
                setDestinoHabilitado(true);
            }
            if(expanded==='Destino'){
                if(props.recoleccionOrigen.esServicioInternacional || props.recoleccionDestino.esServicioInternacional){
                    setExpanded('ComercioExterior');
                    setComercioExteriorHabilitado(true);
                }
                else{
                    setExpanded('Adicional');
                    setAdicionalHabilitado(true);
                }                
            }
            if(expanded==='ComercioExterior'){
                setExpanded('Adicional');
                setAdicionalHabilitado(true);
            }
            setLoading(false);
            setAbierto(false);
        }
    }



    const cerrarCancelarDireccion = () => {
        setShowAlertGeopunto(false);
        setShowBuscoGeopunto(false);
        setAbierto(false)
        
    };

    const cerrarConfirmarDireccion = () => {
        setShowAlertGeopunto(false);
        setShowBuscoGeopunto(false);
        setLoading(true);
        guardaInfoDireccion(true);
        setAbierto(false);
    };

    const cerrarGuardarDireccion = () => {

        setShowAlertGeopunto(false);
        setShowBuscoGeopunto(false);
        setLoading(true);
        guardaInfoDireccion(false);
        setAbierto(false);
    };

    const guardaClienteUbicacion = async (clienteDistribuidor, validada) => {
        if(guardaDireccionCliente){
            return await apiSource.postAsync<any>("cliente-distribuidor-direccion", clienteDistribuidor);
        }
        else{
            return await apiSource.putAsync<any>("cliente-distribuidor-direccion", clienteDistribuidor);
        }
    };

    const guardaInfoDireccion = (validada) => {

        let clienteDisId = 0;
        if(expanded==='Origen'){
            clienteDisId=props.recoleccionOrigen.contacto.clienteDistribuidorID;
        }
        if(expanded==='Destino'){
            clienteDisId=props.recoleccionDestino.contacto.clienteDistribuidorID;
        }
        
        const data = {
            clienteID: props.cliente.id,
            clienteDistribuidorID: clienteDisId,
            direccion: expanded==='Origen' ? props.recoleccionOrigen.direccion : props.recoleccionDestino.direccion,
            latitudOriginal: ubicacionOriginal.latitud,
            longitudOriginal: ubicacionOriginal.longitud,
            latitudVerificada: validada ? (ubicacionVerificada.latitud !== 0 ? ubicacionVerificada.latitud : ubicacionOriginal.latitud) : ubicacionOriginal.latitud,
            longitudVerificada: validada ? (ubicacionVerificada.longitud !== 0 ? ubicacionVerificada.longitud : ubicacionOriginal.longitud) : ubicacionOriginal.longitud,
            l_VERIFICADO: validada

        };
        

        guardaClienteUbicacion(data, validada).then(ubicacion => {                
            setLoading(false);
            setAbierto(false);
            if(expanded==='Origen'){
                setExpanded('Destino');
                setDestinoHabilitado(true);
            }
            if(expanded==='Destino'){
                if(expandedComercioExterior)
                {
                    setExpanded('ComercioExterior');
                    setComercioExteriorHabilitado(true);   
                }
                else
                {
                    setExpanded('Adicional');
                    setAdicionalHabilitado(true);      
                }
            }
            swal.fire({
                titleText: traducirMessage(14), // '¡Exitoso!',
                text: traducirMessage(143), // "La dirección se ha guardado exitosamente.",
                type: 'success',

            });
        

        }).catch(err => {
            setLoading(false);
            setAbierto(false);
            if(expanded==='Origen'){
                setExpanded('Destino');
                setDestinoHabilitado(true);
            }
            if(expanded==='Destino'){
                setExpanded('Adicional');
                setAdicionalHabilitado(true);
            }
            swal.fire({
                titleText: traducirMessage(272), // 'Error!',
                text: traducirMessage(210), // "Ocurrio un error al guardar la dirección.",
                type: 'error',
            });
        });
    }

    const styles = (theme: Theme) =>
        createStyles({
            root: {
            margin: 0,
            padding: theme.spacing(2),
            },
            closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
            },
        });

    const setUbicacionMapa = (ubicacion) => {
        setUbicacionVerificada({ latitud: ubicacion.latitud, longitud: ubicacion.longitud });
    }

    const handleZoomChanged = (currentZoom) => {
        setZoom(currentZoom);
        setCurrentZoom(currentZoom);
    }

    const validarDireccion = () => {
        setShowAlertGeopunto(true);
    }
    
    const handleCloseModal = () => {
        setShowAlert(false);
    }

    const alertText = (
        <Dialog open={abierto} maxWidth={"sm"} onClose={handleCloseModal} >
            <DialogTitle id="simple-dialog-title">
                <span style={{ paddingRight: "65%", paddingLeft: "20px", fontSize: "30px" }}>
                    {/* ¡Alerta! */
                        traducirMessage(273)}
                </span>
                <IconButton aria-label="close" onClick={handleCloseModal}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText style={{ fontSize: "18px", textAlign: "justify" }}>
                    <div style={{ display: "flex" }}>
                        <EditLocation style={{ color: "#00653b", width: "65px", height: "60px" }} />
                        <div style={{ width: "80%" }}>
                            {/* Si el geo punto referenciado en el mapa no corresponde a la ubicación deseada, puede arrastrar el punto hacia al lugar exacto donde se desea. */
                                traducirMessage(263)}
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>

        </Dialog>
    );

    useEffect(() => {
        validaIntraSucursalCruceSucursal();
        }, [
            sucursalCruceId, 
            props.recoleccionOrigen?.areaServicio?.id, 
            props.recoleccionDestino?.areaServicio?.id,
            props.recoleccionOrigen?.sucursal?.id,
            props.recoleccionDestino?.sucursal?.id,
            esInternamientoObligatorio
    ]);

    useEffect(() => { 
        if( ubicacionOriginal.latitud !== 0
            && ubicacionOriginal.longitud !== 0 && avanza
        ){
            setAbierto(true);
        }       
      }, [ubicacionOriginal.latitud,ubicacionOriginal.longitud, avanza])

      useEffect(() => { 
        if(validado){
            if (validado && !abierto && expanded === 'Origen') {
                setExpanded('Destino');
                setDestinoHabilitado(true);
            }
            if (validado && !abierto && expanded === 'Destino') {
                if(props.recoleccionOrigen?.esServicioInternacional || props.recoleccionDestino?.esServicioInternacional){
                    setExpanded('ComercioExterior');
                    setComercioExteriorHabilitado(true);
                }
                else{
                    setExpanded('Adicional');
                    setAdicionalHabilitado(true);
                }         
            }
        }
      },[validado])

    const handleChangePanelDestino = (panel: string) => {
        if (expanded === panel) setExpanded(false);
        else setExpanded(panel);
    };

    const handleSwitchHD = () => {
        setSwitched(!switched);
    }
      
    return (<>
        <div className={classes.root}>
            {props.solicitud.id === 0 &&

                <Accordion expanded={expanded === 'Cotizacion'} onChange={handleChangePanel('Cotizacion')}>
                    <AccordionSummary
                        expandIcon={<Add />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography component={'span'} className={classes.heading}>
                            {/* NO.COTIZACIÓN */
                            traducirLabel(195)}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item sm={11}>
                                <Box>
                                    <TextField
                                        id="standard-textarea"
                                        variant="outlined"
                                        onChange={e => setNoCotizacion(e.target.value)}
                                        value={nocotizacion}
                                        InputProps={{
                                            inputComponent: ReferenciaNumberField as any,
                                            inputProps: { precision: 0, maxLength: 15, min: 0 },
                                        }}
                                    />

                                </Box>
                            </Grid>
                            <Grid item sm={1}>
                                <Button className={classes.icon} color="primary" variant="contained"
                                    onClick={() => buscarCotizacion()}>
                                    <Search />
                                </Button>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            }

            <Accordion expanded={expanded === 'Origen'} onChange={handleChangePanel('Origen')}>
                <AccordionSummary
                    expandIcon={<Add />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography component={'span'} className={classes.heading}>
                        {/* REMITENTE */
                        traducirLabel(262)}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            <div>
                                {expanded === 'Origen' &&
                                    <RecoleccionSolicitud esOrigen={true} value={props.recoleccionOrigen}
                                        siguientePaso={siguientePaso} cotizacionId={props.cotizacionId}
                                        ayuda={props.ayuda} recoleccionOrigen={props.recoleccionOrigen} />
                                }
                            </div>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            { props.cliente.esHomeDelivery  && props.cliente.tieneConveniosHD &&
            <Accordion expanded={expanded === 'Destino'}>
                <AccordionSummary disabled={!destinoHabilitado}
                    expandIcon={<Add 
                        onClick={() => {
                            handleChangePanelDestino('Destino')
                        }}
                        style={{ cursor: "pointer" }}
                      />}
                    aria-controls="panel2a-content"
                    id="panel2a-header">
                    <Grid item sm={9} onClick={() => { handleChangePanelDestino('Destino') }}>
                        <Typography component={'span'} className={classes.heading}>
                            {/* DESTINATARIO */
                            traducirLabel(85)}
                        </Typography>
                    </Grid>  
                    <Grid item sm={3}>
                        <FormControlLabel
                                checked={switched}
                                control={<Switch color="primary" />}
                                label={traducirLabel(342)}
                                onChange={handleSwitchHD}
                            />
                    </Grid>      
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            {expanded === 'Destino' &&
                                <RecoleccionSolicitud esOrigen={false} value={props.recoleccionDestino}
                                    siguientePaso={siguientePaso} cotizacionId={props.cotizacionId}
                                    ayuda={props.ayuda} recoleccionOrigen={props.recoleccionOrigen} />
                            }
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            }
            { (!props.cliente.esHomeDelivery  || !props.cliente.tieneConveniosHD) &&
            <Accordion expanded={expanded === 'Destino'} onChange={handleChangePanel('Destino')}>
                <AccordionSummary disabled={!destinoHabilitado}
                    expandIcon={<Add/>}
                    aria-controls="panel2a-content"
                    id="panel2a-header">
                    <Typography component={'span'} className={classes.heading}>
                        {/* DESTINATARIO */
                        traducirLabel(85)}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            {expanded === 'Destino' &&
                                <RecoleccionSolicitud esOrigen={false} value={props.recoleccionDestino}
                                    siguientePaso={siguientePaso} cotizacionId={props.cotizacionId}
                                    ayuda={props.ayuda} recoleccionOrigen={props.recoleccionOrigen} />
                            }
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            }
            {(props.solicitud.esServicioInternacional || props.recoleccionOrigen.esServicioInternacional || props.recoleccionDestino.esServicioInternacional) &&
            <Accordion expanded={expanded === 'ComercioExterior'} onChange={handleChangePanel('ComercioExterior')}>
                
                <AccordionSummary disabled={!comercioExteriorHabilitado}
                    expandIcon={<Add />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography component={'span'} className={classes.heading}>
                        {/* Comercio Exterior */
                            traducirLabel(344)}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            <ServicioInternacional tieneCruceFronterizo={true} esInternamientoObligatorio={esInternamientoObligatorio} 
                                onSelectCruce={handleCruceInternacional} 
                                onClickIntraUSA={handleIntraUSA}
                                cruceInicialId={props.solicitud?.cruceFronterizo?.cruceInternacionalId}
                                intraUSAInicial={props.solicitud?.cruceFronterizo?.esIntraUSA}
                                limpiarCruceSelected={limpiaCruceFronterizo}
                                sucursalId={sucursalCruceCP}
                                />
                            <NextButton nextStep={guardarComercioExterior} />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            
        }
            <Accordion expanded={expanded === 'Adicional'} onChange={handleChangePanel('Adicional')}>
                <AccordionSummary disabled={!adicionalHabilitado} expandIcon={<Add />} aria-controls="panel2a-content"
                    id="panel2a-header">
                    <Typography component={'span'} className={classes.heading}>
                        {/* ADICIONAL */
                        traducirLabel(4)}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <Help comments={traducirMessage(37)}
                                customStyle={{ top: "-10px", right: "-15px" }} />
                        </Grid>
                        <Grid item sm={12}>
                            <Box mt={2} mb={1} className={classes.headingAdicional}>
                                {/* ¿Desea ingresar algún dato adicional? */
                                traducirMessage(27)}
                            </Box>
                        </Grid>
                        <Grid item sm={12}>
                            <TextField fullWidth
                                id="standard-textarea"
                                variant="outlined"
                                onChange={e => e.target.value.length <= 250 && handleObservaciones(e.target.value)}
                                rows={10} 
                                value={observaciones}
                                multiline
                                inputProps={{ maxLength: 250 }}
                            />
                        </Grid>

                    </Grid>
                </AccordionDetails>
            </Accordion>
            { abierto &&
            <Dialog open={abierto} maxWidth={"xl"} fullWidth={true} >
            <DialogTitle >
            </DialogTitle>
            <DialogContent >
                <DialogContentText>
                    <Container maxWidth="xl"  >
                        <Grid container spacing={2}>
                            <Grid item xs={12} >
                             < Map
                                center={{ lat: ubicacionVerificada.latitud !== 0 ? ubicacionVerificada.latitud : ubicacionOriginal.latitud, lng: ubicacionVerificada.longitud !== 0 ? ubicacionVerificada.longitud : ubicacionOriginal.longitud }}
                                height='500px'
                                zoom={zoom}
                                setUbicacionVerificada={setUbicacionMapa}
                                onZoomChanged={handleZoomChanged}
                            />
                            <Modal
                                open={showAlert}
                                onClose={handleCloseModal}
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            >
                                {alertText}
                            </Modal>
                            </Grid>
                        </Grid>
                        {showAlertGeopunto &&
                            <ConfirmDireccion label={traducirMessage(24) /* ¿Desea continuar con la dirección verificada? */} abierto={showAlertGeopunto} cerrar={cerrarCancelarDireccion} verificar={cerrarConfirmarDireccion} noverificar={cerrarGuardarDireccion} />
                        }
                    </Container>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={validarDireccion} color="primary">
                    {/* Guardar Dirección */
                        traducirButton(14)}
                </Button>
                <Button variant="contained" onClick={mostrarConfirmarCerrar} color="default">
                    {/*CANCELAR*/
                        traducirButton(6)}
                </Button>
            </DialogActions>
            </Dialog>
            
            }
        </div>

        {props.recoleccionDestino.completado && adicionalHabilitado &&
            <Grid container className={classes.actions} style={{ backgroundColor: "white", padding: "10px" }}>
                <Grid item xs={10} />
                <Grid item xs={2}>
                    <Button variant="contained" color="primary" onClick={guardarSeccion}>
                        {/* Continuar */
                        traducirButton(7)}
                    </Button>
                </Grid>
            </Grid>
        }

        {showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    recoleccionOrigen: state.recoleccionOrigen,
    recoleccionDestino: state.recoleccionDestino,
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    usuario: state.usuario,
    serviciosAdicionales: state.serviciosAdicionales,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    updateServicios: updateServicios,
    saveTiposEnvio: saveTiposEnvio,
    saveMercancias: saveMercancias,
    saveCliente: saveCliente,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrigenDestinoSolicitud);
